import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';
import store from './store';
import VueAuthenticate from 'vue-authenticate';
import VueAuthorize from 'vue-authorize';
import aclConfig from './acl-config';
import { createIsAuthorizedDirective } from './is_authorized.mjs';
import mixpanel from 'mixpanel-browser';
import * as Sentry from "@sentry/vue";

Vue.use(VueAuthenticate, {
    baseUrl: '/',
    loginUrl: '/api/login',
    tokenName: 'id'
});
Vue.use(VueAuthorize, aclConfig);
// Replace the plugin's v-is-authorized with a synchronous version that also
// re-checks when the login token or the user's vault role lands after the
// element was mounted. The plugin's directive only re-checked on re-render.
// The store is passed as a function: store.js imports this file, so it is not initialised yet.
Vue.directive('isAuthorized', createIsAuthorizedDirective(aclConfig, () => store));

Vue.use(VueRouter);

const router = new VueRouter({
    routes,
});

let getUserSession = () => {
    return axios.get('/api/login')
        .then((resp) => {
            return resp.data;
        });
}

const mixpanelToken = process.env.MIX_MIXPANEL_TOKEN;
if(mixpanelToken) {
    mixpanel.init(mixpanelToken);
}

router.beforeEach((to, from, next) => {
    if (to.meta && to.meta.public) {
        next();
        return;
    }
    if (router.app.$auth.isAuthenticated() === false) {
        store.dispatch('login');
    } else {
        if (_.isEmpty(store.getters.getUser)) {
            getUserSession().then((user) => {
                if (_.isEmpty(user)) {
                    window.location.href = '/auth-login';
                } else {
                    store.commit('isAuthenticated', {
                        isAuthenticated: router.app.$auth.isAuthenticated()
                    })
                    store.commit('setUser', user);
                    if(user) {
                        Sentry.setUser({
                            id: user.id
                        })
                    } else {
                        Sentry.setUser(null);
                    }
                }
            })
        }

        if(mixpanelToken) {
            mixpanel.track_pageview({page: to?.name ?? ''});
        }

        // Locked vault: only allow Update Billing page
        const vaultId = to.params.vault_id;
        if (vaultId && to.name !== "update-billing-details") {
            const vaults = store.getters.getVaults || [];
            const vault = vaults.find((v) => String(v.id) === String(vaultId));
            const isLocked = vault && (vault.subscription_id == null || vault.subscription_id === "");
            if (isLocked) {
                next({ name: "update-billing-details", params: { vault_id: vaultId } });
                return;
            }
        }
    }
    next();
});

export default router;